import React from 'react';
import PropTypes from 'prop-types';

import CriteriumScreenshots from '@hydra/common/criterium/CriteriumScreenshots';
import Criterium from '@hydra/common/criterium/Criterium';

export const MobileRendering = ({ criterium }) => {
  const { data } = criterium;

  return (
    <Criterium criterium={criterium}>
      <CriteriumScreenshots {...data} />
    </Criterium>
  );
};

MobileRendering.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      phone: PropTypes.string,
      tablet: PropTypes.string
    })
  })
};

export default React.memo(MobileRendering);
